export default {
  a0: '绑定上级',
  a1: '请输入上级地址',
  a2: '提交',
  a3: '请使用币安智能链',
  a4: '请输入正确的钱包地址',
  a5: '等待链上确认',
  a6: '已绑定',
  a7: '操作失败',
  a8: 'NX流动性',
  a9: '奖励池',
  b0: '托底池',
  b1: '认购节点',
  b2: '节点认购中',
  b3: '已认购',
  b4: '立即参与',
  b5: '认购结束',
  b6: '参与质押',
  b7: '参与金额',
  b8: '我的余额',
  b9: '请输入金额',
  c0: '认购节点需支付',
  c1: '取消',
  c2: '确认',
  c3: '区块链确认中请稍后',
  c4: '质押成功',
  c5: '参与质押成功',
  c6: '质押天数',
  c7: '质押金额',
  c8: '日收益',
  c9: '余额不足',
  d0: '认购成功',
  d1: '请输入有效的参与金额',
  d2: '可用余额不足',
  d3: '不在参与时间段',
  d4: 'GAS费用不足',
  d5: '总单数',
  d6: '总金额',
  d7: '进行中',
  d8: '待赎回',
  d9: '已完成',
  e0: '质押数量',
  e1: '已收益',
  e2: '赎回质押',
  e3: '暂无数据',
  e4: '加载中',
  e5: '已赎回',
  e6: '首页',
  e7: '质押记录',
  e8: '我的',
  e9: 'NFT获取方式A',
  f0: '总邀请{num}位节点用户获得NFT',
  f1: '还需要邀请节点用户',
  f2: '个',
  f3: 'NFT获取方式B',
  f4: '晋升“V5”级别获得NFT',
  f5: '小部门业绩还差',
  f6: '我的NFT',
  f7: '编号',
  f8: '转让',
  f9: '转让NFT',
  g0: '请输入转让的地址',
  g1: '请输入正确的转让地址',
  g2: '已转让',
  g3: '是一个全球性的预测平台',
  g4: '交易NX',
  g5: '暂未开放',
  g6: 'CHENXIANG 生态',
  g7: '团队奖金额度',
  g8: '我的收益',
  g9: '查看详情',
  h0: '我的级别',
  h1: '节点用户',
  h2: '有效用户',
  h3: '距离晋升下一个职务团队',
  h4: '团队业绩还差',
  h5: '我的社区',
  h6: '邀请链接',
  h7: '复制',
  h8: '我的上级',
  h9: '个人业绩',
  i0: '团队业绩',
  i1: '已复制',
  i2: '复制失败',
  i3: '收益记录',
  i4: '节点推荐',
  i5: '质押收益',
  i6: '团队收益',
  i7: '节点释放',
  i8: '节点分红',
  i9: 'NFT分红',
  j0: '60天质押奖励',
  j1: '查看更多',
  j2: '质押奖励',
  j3: '暂无权限',
  j4: '团队总业绩',
  j5: '团队地址数',
  j6: '有效团队地址数'
}
